<template>
  <section id="projects">
    <h2 class="section-header">Projects</h2>
    <div class="project-list">
      <div
        v-for="project in projects"
        :key="project.title"
        class="project-card"
      >
        <div class="card-header">
          <div class="header-top">
            <span class="period code-font">{{ project.period }}</span>
            <span class="role-badge" :class="project.roleType">{{
              project.role
            }}</span>
          </div>
          <p class="period code-font">{{ project.team }}</p>
          <h3 class="project-title">{{ project.title }}</h3>
          <p class="summary">{{ project.description }}</p>

          <div class="tech-stack">
            <span v-for="tech in project.stack" :key="tech" class="tech-pill">{{
              tech
            }}</span>
          </div>
        </div>

        <div class="card-body">
          <div class="project-section">
            <h4>시스템 아키텍처</h4>
            <div class="architecture-box">
              <p>{{ project.architecture }}</p>
            </div>
          </div>

          <div class="content-block" style="margin-top: 25px">
            <h4>Key Achievements</h4>
            <ul>
              <li
                v-for="(item, idx) in project.achievements"
                :key="idx"
                v-html="item"
              ></li>
            </ul>
          </div>

          <div
            class="content-block"
            v-if="project.troubleshooting && project.troubleshooting.length > 0"
          >
            <h4>Troubleshooting</h4>
            <div class="trouble-grid">
              <div
                v-for="ts in project.troubleshooting"
                :key="ts.title"
                class="trouble-item"
              >
                <h5 class="trouble-title">{{ ts.title }}</h5>
                <br />
                <h5 class="trouble-title">{{ ts.problem }}</h5>
                <p class="trouble-desc">{{ ts.solution }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="card-footer">
          <a :href="project.github" target="_blank" class="github-link"></a>
        </div>
        <br />
        <br />
        <br />
        <br />
      </div>
    </div>
  </section>
</template>

<script>
// 이미지 파일들은 기존 경로에 맞게 사용하세요
import Project1Pic from "@/assets/project1.png";
import Project2Pic from "@/assets/project2.png";
import Project3Pic from "@/assets/project3.png";

export default {
  name: "ProjectsSection",
  data() {
    return {
      projects: [
        {
          title: "AIxLogistics - 실시간 대규모 물류 관제 & AI 경로 탐색 시스템",
          // 이미지가 있다면 import해서 넣으세요. 없으면 생략 가능합니다.
          // image: ProjectLogisticsPic,
          period: "2025.10 - 진행중",
          team: "개인 프로젝트",
          role: "Backend Engineer",
          roleType: "backend",
          description:
            "OpenStreetMap 지리 데이터를 기반으로 로봇의 최적 경로를 계산하고 수만 개의 IoT 센서 데이터를 실시간으로 시각화하는 지능형 물류 관제 플랫폼입니다.",
          architecture:
            "Robot → Kafka → Backend (WebFlux) → Redis & WebSocket. 경로 탐색은 GraphHopper(OSM) 엔진 사용.",
          stack: [
            "Kotlin",
            "Spring WebFlux",
            "Coroutines",
            "Kafka",
            "GraphHopper",
            "OpenStreetMap",
            "Redis",
            "PostgreSQL",
            "WebSocket",
            "Docker",
          ],
          achievements: [
            "<strong>GraphHopper 엔진</strong>과 <strong>OpenStreetMap(OSM) 데이터</strong>를 활용하여 실제 도로망 기반의 <strong>로봇 최적 경로 탐색(Routing) 알고리즘</strong> 구현.",
            "<strong>초당 100건 이상의 대규모 데이터 스트림</strong>을 안정적으로 처리하기 위해 <strong>Kafka 기반의 이벤트 파이프라인</strong> 구축.",
            "<strong>Spring WebFlux와 Kotlin Coroutines</strong>를 도입하여 Blocking I/O 문제를 해결하고 스레드 효율성 극대화.",
            "실제 하드웨어 없이 부하 테스트를 수행하기 위해 <strong>가상 로봇 시뮬레이터</strong>를 직접 구현하여 시스템 안정성 검증.",
            "Kafka Consumer에서 WebSocket으로 이어지는 <strong>실시간 브로드캐스팅 시스템</strong> 구현 (Latency 최소화).",
          ],
          troubleshooting: [
            {
              title: "왜 MVC 대신 WebFlux를 선택했는가?",
              problem:
                "수만 대의 로봇이 동시에 데이터를 보낼 때 기존 Thread-per-Request 방식의 Spring MVC는 스레드 고갈 위험이 있었습니다.",
              solution:
                "적은 수의 스레드로 대량의 동시 접속을 처리하기 위해 Event Loop 기반의 WebFlux(Netty)와 Non-Blocking DB 드라이버(R2DBC)를 도입하여 처리량을 극대화하고 시스템 리소스를 효율적으로 사용했습니다.",
            },
            {
              title: "데이터 유실 방지와 시스템 결합도 낮추기",
              problem:
                "시뮬레이터의 데이터 생성 속도가 폭증하는 버스트 트래픽 상황에서 서버가 이를 즉시 처리하지 못하면 데이터 유실이 발생할 수 있었습니다.",
              solution:
                "생산자와 소비자 사이에 Kafka를 버퍼로 두어 트래픽을 완충하고 시스템 간의 결합도를 낮추어 유연하고 안정적인 데이터 파이프라인을 구축했습니다.",
            },
          ],
          github: "https://github.com/kimdavid0521/AIxLogistics", // 실제 주소로 변경 필요
        },
        {
          title: "EducationClass - 온라인 교육 관리 플랫폼",
          image: Project1Pic,
          period: "2024.08 - 2024.10",
          team: "개인 프로젝트",
          role: "Backend Engineer",
          roleType: "backend",
          description:
            "WebRTC와 STOMP를 활용한 실시간 양방향 온라인 코딩 교육 플랫폼입니다. 기획 및 백엔드 시스템 전체를 설계하고 개발했습니다.",
          architecture:
            "User → ALB → EC2 (Spring Boot) → RDS (MySQL) & S3. 실시간 통신은 STOMP 브로커를 통해 WebSocket으로 처리.",
          stack: [
            "Java",
            "Spring Boot",
            "JPA",
            "QueryDSL",
            "WebRTC",
            "STOMP",
            "MySQL",
            "AWS",
            "CI/CD",
          ],
          achievements: [
            "WebRTC와 STOMP를 도입하여 <strong>실시간 양방향 화상/채팅 기능</strong> 구현.",
            "15분짜리 수동 배포 프로세스를 CI/CD 파이프라인 구축하여 <strong>3분으로 단축</strong>.",
            "강의 목록 조회 API에서 발생한 N+1 문제를 Fetch Join으로 해결 -> <strong>DB 쿼리 수를 50개 이상에서 2개로 줄이고 응답 속도를 80% 개선</strong>.",
          ],
          troubleshooting: [
            {
              title: "왜 Fetch Join을 선택했는가?",
              problem:
                "강의 목록 조회 기능 구현 시 Lazy Loading으로 인해 N+1 문제가 발생했습니다. Eager Loading, Batch Size 조절, Fetch Join이라는 세 가지 선택지 중 최적의 해결책을 찾아야 했습니다.",
              solution:
                "Eager Loading은 불필요한 데이터까지 조회할 수 있어 제외했고 Batch Size 조절은 근본적인 해결책이 아니라고 판단했습니다. 최종적으로 필요한 연관 데이터만 명시적으로 함께 조회하는 Fetch Join을 선택하여 데이터베이스 부하와 애플리케이션 오버헤드를 최소화했습니다.",
            },
            {
              title: "AWS ALB Health Check 실패로 인한 서비스 다운 문제 해결",
              problem:
                "CI/CD 배포 후 인프라 설정이 올바름에도 불구하고 ALB 대상 그룹의 Health Check가 계속 실패하여 인스턴스가 unhealthy 상태로 표시되고 서비스 접속이 불가능했습니다.",
              solution:
                "로그 분석을 통해 문제의 원인이 인프라가 아닌 Spring Security 설정에 있음을 발견했습니다. ALB가 보내는 인증 정보 없는 Health Check 요청을 Spring Security가 차단하고 있었습니다. 이를 해결하기 위해 인증을 받지 않는 전용 Health Check API를 구현하고 해당 경로를 예외 처리하여 문제를 해결했습니다.",
            },
          ],
          github: "https://github.com/kimdavid0521/EducationClassProject",
        },
        {
          title: "Fund:ing - AI 기반 핀테크 펀딩 플랫폼",
          image: Project2Pic,
          period: "2025.06 - 2025.08",
          team: "5인 프로젝트",
          role: "Backend Engineer PL, Frontend Engineer",
          roleType: "fullstack",
          description:
            "AI 기술을 접목하여 사용자 맞춤형 경험을 제공하는 핀테크 펀딩 플랫폼입니다. 프론트엔드, 백엔드, 배포까지 전 과정에 참여했습니다.",
          architecture:
            "User → Web (Vue.js) → API Gateway → EC2 (Spring Legacy) → RDS (MySQL). 이미지 처리는 S3, AI 분석은 OpenAI Vision과 연동.",
          stack: [
            "Java",
            "Spring Legacy",
            "MyBatis",
            "Vue.js",
            "OpenAI API",
            "Docker",
            "MySQL",
            "AWS S3",
          ],
          achievements: [
            "이미지 수동 검증 프로세스를 OpenAI Vision으로 자동화하여 <strong>운영 리소스 90% 이상 절감</strong>.",
            "관리자 대시보드 기능 <strong>프론트엔드(Vue.js)와 백엔드 API(Spring)를 구현</strong>.",
            "금융 상품 조회 쿼리에서 대량의 JOIN으로 인한 성능 저하를 <strong>MySQL의 WITH절(CTE)을 활용하여 개선</strong>.",
            "JUnit5를 활용하여 서비스의 핵심 로직에 대한 단위 테스트 코드를 작성하고 테스트 커버리지를 관리하며 시스템의 안정성 확보.",
            "Docker 도입하여 내장 톰캣이 없는 <strong>Spring Legacy 환경의 AWS 배포 프로세스를 컨테이너화하여 표준화</strong>.",
          ],
          troubleshooting: [
            {
              title: "복잡한 동적 쿼리와 MyBatis의 한계",
              problem:
                "다양한 조건으로 상품을 필터링하는 기능에서 MyBatis의 XML 기반 동적 쿼리가 지나치게 복잡해지고 여러 테이블을 JOIN할 때 불필요한 Full Scan이 발생하여 성능이 저하되었습니다.",
              solution:
                "단순 JOIN 대신 WITH절(CTE)을 사용하여 필요한 데이터를 미리 필터링하고 그룹화한 임시 결과 집합을 만들었습니다. 이후 이 임시 집합들을 JOIN하여 최종 결과를 도출함으로써 쿼리를 최적화하고 복잡했던 XML 코드의 가독성을 향상시켰습니다.",
            },
            {
              title: "AI 응답 형식 불안정성 문제",
              problem:
                "OpenAI가 간헐적으로 지정된 JSON 형식이 아닌 일반 텍스트나 불완전한 형태로 응답하여 JSON 파싱 에러 및 서비스 장애로 이어질 수 있었습니다.",
              solution:
                "안정성 확보를 위해 JSON 추출, 재시도, 예외 처리의 다층적 방어 로직을 포함한 헬퍼 메서드를 구현하여 비정형적인 응답에도 서비스가 안정적으로 동작하도록 만들었습니다.",
            },
          ],
          github: "https://github.com/Jejudo-Ticket/server",
        },
        {
          title: "majorLink - 대학생 전공 상호 멘토링 플랫폼",
          image: Project3Pic,
          period: "2024.07 - 2024.08",
          team: "7인 프로젝트",
          role: "Backend Engineer PL, Frontend Engineer",
          roleType: "fullstack",
          description:
            "전공 선택에 대한 고민을 해결하기 위해 대학생들이 서로의 전공 지식을 교환하고 소통하는 화상 멘토링 플랫폼입니다.",
          architecture:
            "User → ALB → EC2 (Spring Boot) → RDS (MySQL). 실시간 통신은 WebRTC, 배포는 Docker & GitHub Actions CI/CD 파이프라인으로 구성.",
          stack: [
            "Java",
            "Spring Boot",
            "WebRTC",
            "STOMP",
            "Iamport",
            "Docker",
            "GitHub Actions",
            "AWS EC2",
          ],
          achievements: [
            "<strong>WebRTC</strong>와 Google STUN 서버를 이용해 NAT 환경에서도 안정적인 <strong>실시간 화상 통화 기능</strong> 구현.",
            "<strong>Docker와 GitHub Actions를 활용</strong>해 코드 변경 시 자동으로 서버에 반영되는 <strong>CI/CD 파이프라인 구축</strong>.",
            "결제 기능 위/변조 취약점을 발견하고 서버 사이드 검증 로직을 추가하여 원천 차단.",
          ],
          troubleshooting: [
            {
              title: "왜 Docker Multi-stage 빌드를 도입했는가?",
              problem:
                "단일 Dockerfile로 이미지를 빌드한 결과 JDK 등 개발 도구까지 최종 이미지에 포함되어 용량이 불필요하게 커지고 빌드 시간이 길어지는 비효율이 발생했습니다.",
              solution:
                "Dockerfile 내에 빌드와 실행 단계를 분리하는 Multi-stage 빌드를 도입했습니다. 빌드용 이미지에서 생성된 `.jar` 파일만 실행용 JRE 이미지로 복사함으로써 최종 이미지에는 오직 실행에 필요한 파일만 담아 크기를 절반 가까이 줄이고 CI/CD 파이프라인의 속도를 개선했습니다.",
            },
            {
              title: "결제 위/변조 취약점 발견 및 서버 사이드 검증 강화",
              problem:
                "클라이언트에서 결제 금액을 조작하여 요청할 경우 실제 상품 가격과 다른 금액으로 결제가 완료될 수 있는 보안 취약점을 발견했습니다.",
              solution:
                "결제 완료 후 서버가 직접 Iamport API에 결제 정보를 재조회하고 DB의 주문 금액과 교차 검증하는 로직을 추가했습니다. 이를 통해 금전적 손실을 야기할 수 있는 보안 허점을 원천 차단했습니다.",
            },
          ],
          github: "https://github.com/orgs/TeamMajorLink/repositories",
        },
        {
          title: "ITer - IT 초보자를 위한 스마트 IT 서비스",
          period: "2023.11 - 2024.03",
          team: "5인 프로젝트",
          role: "Frontend Engineer",
          roleType: "frontend",
          description:
            "IT 제품 리뷰 및 퀴즈 서비스입니다. 백엔드 개발자로서 프론트엔드 데이터 관리의 어려움을 직접 경험하고, 효율적인 API 설계를 고민하기 위해 프론트엔드 개발을 주도했습니다.",
          architecture:
            "User → Vercel (React SPA) → Backend API Server. React Query를 도입하여 서버 데이터와 UI 상태를 분리하여 관리.",
          stack: ["React", "TypeScript", "React Query", "Vite", "Vercel"],
          achievements: [
            "<strong>Atomic Design 패턴을 적용</strong>하여 컴포넌트를 계층적으로 분리하고, <strong>공통 UI 컴포넌트(Button, Input 등)를 모듈화</strong>하여 코드 재사용성을 극대화.", // 추가된 부분
            "프로젝트 초기 단계에 <strong>TypeScript 도입을 주도</strong>하여 코드 안정성과 유지보수성을 크게 향상.",
            "<strong>React Query를 도입</strong>하여 서버 상태 관리 로직을 개선, 불필요한 API 호출 수를 <strong>40% 감소</strong>시키고 캐싱 전략을 구현.",
          ],
          troubleshooting: [
            {
              title: "기술 의사결정: 왜 React Query를 선택했는가?",
              problem:
                "useEffect와 useState만으로 서버 데이터를 관리했을 때 로딩 및 에러 상태 처리를 위한 보일러플레이트 코드가 많아지고 캐싱이 없어 불필요한 API 재요청이 빈번하게 발생하는 문제가 있었습니다.",
              solution:
                "서버 상태와 클라이언트 상태를 분리하는 철학에 동의하여 React Query 도입을 결정했습니다. 캐싱, 동기화, 업데이트 로직을 라이브러리에 위임함으로써 컴포넌트의 코드를 비즈니스 로직에만 집중하도록 단순화하고 stale-while-revalidate 전략으로 사용자 경험과 성능을 모두 개선했습니다.",
            },
            {
              title: "컴포넌트 중복과 유지보수성 문제 해결",
              problem:
                "페이지가 늘어날수록 버튼, 인풋 창 등 비슷한 UI 코드가 중복 작성되었고, 디자인 수정 사항이 생길 때마다 수십 개의 파일을 일일이 수정해야 하는 유지보수 문제가 발생했습니다.",
              solution:
                "UI 요소를 가장 작은 단위부터 조립하는 Atomic Design 패턴을 적용하여 공통 컴포넌트를 모듈화했습니다. 또한 TypeScript Interface를 활용해 확장 가능한 Props 구조를 설계함으로써, 팀원들이 내부 로직을 몰라도 안전하고 쉽게 재사용할 수 있는 환경을 구축했습니다.",
            },
          ],
          retrospective:
            "백엔드 개발자로서 프론트엔드 프로젝트를 주도해보며 사용자의 입장을 깊이 이해하게 되었습니다. React Query를 통해 서버 상태를 직접 관리하며 어떤 API가 프론트엔드 개발을 편리하게 만들고 어떤 데이터 구조가 재사용성을 높이는지를 직접 느꼈습니다. 효율적이고 협업하기 좋은 백엔드 시스템을 설계하는 역량을 기를 수 었었습니다.",
          github: "https://github.com/BETTER-iTER",
        },
      ],
    };
  },
};
</script>

<style scoped>
.section-header {
  font-size: 3rem;
  margin-bottom: 80px;
  color: var(--text-primary);
}

.project-card {
  margin-bottom: 100px;
  padding-bottom: 60px;
  border-bottom: 1px solid var(--border-color);
}

.project-card:last-child {
  border-bottom: none;
}

/* Header Styling */
.header-top {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;
}

.period {
  color: var(--text-tertiary);
  font-size: 0.9rem;
}

.role-badge {
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.role-badge.backend {
  background: rgba(79, 70, 229, 0.1);
  color: #4f46e5;
}
.role-badge.frontend {
  background: rgba(234, 179, 8, 0.1);
  color: #ca8a04;
}
.role-badge.fullstack {
  background: rgba(16, 185, 129, 0.1);
  color: #059669;
}

.project-title {
  font-size: 2.5rem;
  margin-bottom: 15px;
  color: var(--text-primary);
}

.summary {
  font-size: 1.1rem;
  color: var(--text-secondary);
  max-width: 800px;
  margin-bottom: 25px;
}

.tech-stack {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 40px;
}

.tech-pill {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 0.85rem;
  color: var(--text-secondary);
  font-family: "JetBrains Mono", monospace;
}

/* Body Styling */
.project-section h4,
.content-block h4 {
  font-size: 1rem;
  color: var(--text-tertiary);
  text-transform: uppercase;
  margin-bottom: 15px;
  letter-spacing: 0.05em;
}

/* Architecture Box 추가 */
.architecture-box {
  background: var(--bg-secondary);
  padding: 15px 20px;
  border-radius: 8px;
  border: 1px dashed var(--border-color);
  font-family: "JetBrains Mono", monospace;
  font-size: 0.9rem;
  color: var(--text-secondary);
  margin-bottom: 30px;
}

.content-block ul li {
  color: var(--text-secondary);
  margin-bottom: 8px;
  line-height: 1.7;
}

/* Troubleshooting Grid */
.trouble-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.trouble-item {
  background: var(--bg-secondary);
  padding: 20px;
  border-radius: 12px;
  border-left: 3px solid var(--accent-color);
}

.trouble-title {
  font-size: 1rem;
  margin-bottom: 8px;
  color: var(--text-primary);
}

.trouble-desc {
  font-size: 0.9rem;
  color: var(--text-secondary);
  margin: 0;
}

.github-link {
  display: inline-block;
  margin-top: 20px;
  color: var(--accent-color);
  font-weight: 600;
  text-decoration: none;
  border-bottom: 2px solid transparent;
  transition: all 0.2s;
}
.github-link:hover {
  border-bottom-color: var(--accent-color);
}

@media (max-width: 768px) {
  .project-title {
    font-size: 2rem;
  }
  .trouble-grid {
    grid-template-columns: 1fr;
  }
}
</style>
